// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__bSNGP","circle-loading":"Loading_circle-loading__yPs5u"};